<div *ngIf="rowCount && rowCountDisplay" class="row-count-display">{{ rowCountDisplay }} Rows</div>
<ag-grid-angular
  [ngClass]="{ 'hide-filter-menu': shouldHideFilterMenu, 'with-footer': hasFooter }"
  class="ag-grid-angular-class"
  [theme]="myTheme"
  [rowSelection]="rowSelection"
  [selectionColumnDef]="selectionColumnDef"
  [rowData]="rowData"
  [columnDefs]="colDefs"
  [gridOptions]="gridOptions"
  [getContextMenuItems]="customContextMenu"
  [detailCellRenderer]="detailCellRenderer"
  [detailCellRendererParams]="detailCellRendererParams"
  (gridReady)="this.onGridReady($event)"
  (rowSelected)="onRowSelected($event)"
  [masterDetail]="masterDetail"
  [detailRowAutoHeight]="detailRowAutoHeight"
  [pinnedBottomRowData]="pinnedBottomRowData"
  [serverSideDatasource]="serverSideDatasource"
  (selectionChanged)="onSelectionChanged()"
  [isExternalFilterPresent]="isExternalFilterPresent"
  [doesExternalFilterPass]="doesExternalFilterPass"
  (modelUpdated)="countShownRows()"
>
</ag-grid-angular>

<!-- How many rows, why fewer are shown, and the next page when they come page by page: the same words on every page -->
<div class="grid-footer" *ngIf="hasFooter">
  <span class="grid-footer-count" *ngIf="showCount" [attr.title]="countParts.loaded ? 'The rows loaded so far' : null">
    <svg-icon class="gap-icon grid-footer-icon" src="assets/icons/table.svg" aria-hidden="true"></svg-icon>
    <!-- The spaces are in the bindings: Angular drops those between elements -->
    <span>
      {{ 'Showing ' }}<strong *ngIf="countParts.shown">{{ countParts.shown }}</strong>{{ countParts.shown ? ' of ' : '' }}{{ countParts.all ? 'all ' : ''
      }}<strong>{{ countParts.total }}</strong>{{ ' ' + countParts.label }}{{ countParts.loaded ? ' loaded' : '' }}
    </span>
  </span>
  <span class="grid-footer-note" *ngFor="let note of footerNotes; let first = first">
    <span *ngIf="showCount || !first" class="grid-footer-dot" aria-hidden="true">·</span>{{ ' ' + note }}
  </span>
  <!-- On the right: which rows the next page holds, and the button that brings them -->
  <span *ngIf="hasMore" class="grid-footer-more">
    <span class="grid-footer-more-text">{{ moreText }}</span>
    <button nz-button nzSize="small" type="button" [nzLoading]="loadingMore" (click)="requestMore()">Load more</button>
  </span>
</div>
